<template>
  <div
    class="why-us-reason h-full grid grid-cols-1"
    v-bind:class="`md:grid-cols-${span}`"
  >
    <div>
      <div class="icon flex justify-center items-center">
        <font-awesome-icon :icon="[iconStyle, icon]" />
      </div>
      <h4 class="font-bold mb-4 text-2xl">{{ title }}</h4>
    </div>
    <div>
      <p class="text-justify" v-html="description" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    span: {
      type: Number,
      default: 1,
    },
    icon: String,
    title: String,
    description: String,
    iconStyle: {
      type: String,
      default: "fas",
    },
  },
};
</script>

<style lang="scss" scoped>
.why-us-reason {
  @apply bg-white p-6 text-center rounded-lg;

  @screen md {
    @apply p-12;
  }

  .icon {
    @apply rounded-full bg-primary-color mx-auto mb-12 text-black text-5xl;

    width: 130px;
    height: 130px;
    line-height: 130px;
  }
}
</style>
